import React from 'react'
import { AppBar, Paper, Tab, Tabs } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useFormikContext } from 'formik'
import { IRevenueGroupAdministration } from '@cbgms/api'

interface IProps {
  tabErrors: any[] | undefined
  tabIndex: number
  changeTabIndex: (index: number) => void
}

const useStyles = makeStyles(theme => ({
  errorIndicator: {
    backgroundColor: theme.palette.error.light
  },
  tabError: {
    color: theme.palette.error.light
  },
  tabSelected: {
    color: theme.palette.primary.main
  }
}))

const AdministrationTabs: React.FC<IProps> = ({ tabErrors, tabIndex, changeTabIndex }) => {
  const {
    values: { Administrations }
  } = useFormikContext<IRevenueGroupAdministration>()
  const classes = useStyles()

  return (
    <Paper sx={{ mb: 1 }}>
      <AppBar position='static' color='transparent' elevation={1}>
        <Tabs
          value={tabIndex}
          onChange={(_event, newValue) => {
            changeTabIndex(newValue)
          }}
          indicatorColor='primary'
          classes={{ indicator: tabErrors?.length ? classes.errorIndicator : undefined }}
        >
          {Administrations.map((administration, index) => {
            const tabClasses = tabErrors?.[index]?.Ledgers?.length ? classes.tabError : tabIndex === index ? classes.tabSelected : undefined
            return (
              <Tab
                key={administration.AdministrationCode}
                label={administration.AdministrationDescription}
                value={index}
                className={tabClasses}
              />
            )
          })}
        </Tabs>
      </AppBar>
    </Paper>
  )
}

export default AdministrationTabs
